export default "__VITE_ASSET__CXBw3SHN__"